/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import {useSelector, useDispatch } from 'react-redux'
import styles from './UserProfile.module.css';
import { Button, PopoverPaper } from '../../atomicComponents';
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';
import { sanitizeCoCodeNumeric, sanitizeNumeric } from '../../utils/utils';

const UserProfile = ({ open, handleClose, anchorEl }) => {
  const baseUrl = useSelector(state => state.counter.baseUrl);  // useSelector
  const dispatch = useDispatch();
  const { user, logoutUser } = useAuthorizationContext();
  const handleLogout = () => {
    const apiFormatedData = 
      {
        "pers_no":sanitizeNumeric(user.personNumber),
        "co_code":sanitizeCoCodeNumeric(user.companyCode),
        "session_id":user.sessionId,  

      }
    console.log(apiFormatedData);
    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append('Content-Type', 'application/json');
    fetch(`${baseUrl}master/erc_ldaplogout`,
      {
        method: 'POST',
        headers: headerss,
        credentials:'include',
        body: apiFormatedDataJson
      }).then((response) => response.json())
      .then((responseJson) => {
        if (responseJson) {
          logoutUser(dispatch)
          localStorage.clear();
          sessionStorage.clear()
          if(responseJson.msg==="User logged out successfully"){
            logoutUser(dispatch)
          }
      }
      })
      .catch((error) => {
        console.info(error)
      });
  }
  return (
    <PopoverPaper
      open={open}
      handleClose={handleClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <div className={styles.display}>
        <div className={styles.iconContainer}>
          <PersonOutlineOutlinedIcon className={styles.personIcon} />
        </div>
        <div className={styles.details}>
          <span className={styles.name}>{user?.userName}</span>
          <span className={styles.email}>{user?.email}</span>
          <Button
            ignoreExistingClassNames
            className={styles.logoutButton}
            startIcon={<PowerSettingsNewIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </div>
      </div>
    </PopoverPaper>
  )
};

UserProfile.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.instanceOf(Element),
};

export default UserProfile;